import { Injectable } from '@angular/core';
import { LocalStorageService } from './local-storage.service';
import { CallCenter, Center, Group, GroupsResponse, HierarchicalData, OptionItem, RoleFilterSelected, SubGroup } from '../shared/role-filter-dropdown-row/role-filter-dropdown-row.component';
import { LocalStorageKeys } from '../core/enums/LocalStorageKeys';
import { UserService } from './user.service';
import { map, Observable, of, switchMap, take, catchError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/auth.service';
import { HttpClient } from '@angular/common/http';
import { MyAccountService } from '../pages/my-account/services/my-acount.service';
import { UserProfile } from '../pages/my-account/interfaces/company-settings.interface';
import { RoleFiltesGuid } from '../pages/reports/interfaces/report-filters.model';

const mockResponse: GroupsResponse = [
  {
    GroupId: "e3637003-9dfd-4946-9b30-a2093cea8cea",
    SubGroups: [
      {
        SubGroupId: "87901234579017590128375",
        SubGroupName: "Subgroup A",
        Centers: [
          {
            CenterId: "910158591247172498124424124",
            CenterName: "Test Center A1",
            Users: [
              {
                UserGuidDetails: "2ea35a86-59d7-409c-a0ea-0412d8648378",
                DisplayName: "Vicky Zhao"
              },
              {
                UserGuidDetails: "154b039f-9ae6-4f7e-8508-8fdb980dfd85",
                DisplayName: "Grace Mites"
              },
              {
                UserGuidDetails: "1fef401c-9c9c-4133-b0a0-fdb50dd1dbb5",
                DisplayName: "Mark Lin"
              }
            ]
          },
          {
            CenterId: "23456289374659283756278935",
            CenterName: "Test Center A2",
            Users: [
              {
                UserGuidDetails: "3aa4a8d4-5f33-44b5-9c29-9aa11bb22cc3",
                DisplayName: "Lucía Fernández"
              },
              {
                UserGuidDetails: "4cc5d1f2-7e99-42a3-812c-3aa11bb33cc4",
                DisplayName: "David Park"
              }
            ]
          }
        ],
        CallCenters: [{
          CallCenterId: "tur30fu908gfu89023th13984ty78234ty",
          CallCenterName: "Call Center 1",
          Centers: [
            {
              CenterId: "b2233445-5566-7788-8899-aabbccddeeff",
              CenterName: "Research Center B1",
              Users: [
                {
                  UserGuidDetails: "7baf40a4-b41e-43aa-9b77-cbb44001122f",
                  DisplayName: "Sara Gómez"
                },
                {
                  UserGuidDetails: "8cde22f3-9aa4-41ff-8334-dde122ff3344",
                  DisplayName: "Tom Lee"
                }
              ]
            },
            {
              CenterId: "c3344556-6677-7788-8899-bbccddeeff00",
              CenterName: "Innovation Center B2",
              Users: [
                {
                  UserGuidDetails: "9ddf50b4-5f4e-47ee-9999-ccddee445566",
                  DisplayName: "Isabella Rossi"
                },
                {
                  UserGuidDetails: "0eea33c3-6b6b-41ac-9999-ccddeeff1122",
                  DisplayName: "James Smith"
                }
              ]
            }
          ]
        }]
      },
      {
        SubGroupId: "11111111-1111-1111-1111-111111111111",
        SubGroupName: "Subgroup B",
        CallCenters: [{
          CallCenterId: "tur30fu908gfu89023th13984ty78234ty",
          CallCenterName: "Call Center 1",
          Centers: [
            {
              CenterId: "b2233445-5566-7788-8899-aabbccddeeff",
              CenterName: "Research Center B1",
              Users: [
                {
                  UserGuidDetails: "7baf40a4-b41e-43aa-9b77-cbb44001122f",
                  DisplayName: "Sara Gómez"
                },
                {
                  UserGuidDetails: "8cde22f3-9aa4-41ff-8334-dde122ff3344",
                  DisplayName: "Tom Lee"
                }
              ]
            },
            {
              CenterId: "c3344556-6677-7788-8899-bbccddeeff00",
              CenterName: "Innovation Center B2",
              Users: [
                {
                  UserGuidDetails: "9ddf50b4-5f4e-47ee-9999-ccddee445566",
                  DisplayName: "Isabella Rossi"
                },
                {
                  UserGuidDetails: "0eea33c3-6b6b-41ac-9999-ccddeeff1122",
                  DisplayName: "James Smith"
                }
              ]
            }
          ]
        }],
        Centers: [
          {
            CenterId: "b2233445-5566-7788-8899-aabbccddeeff",
            CenterName: "Research Center B1",
            Users: [
              {
                UserGuidDetails: "7baf40a4-b41e-43aa-9b77-cbb44001122f",
                DisplayName: "Sara Gómez"
              },
              {
                UserGuidDetails: "8cde22f3-9aa4-41ff-8334-dde122ff3344",
                DisplayName: "Tom Lee"
              }
            ]
          },
          {
            CenterId: "c3344556-6677-7788-8899-bbccddeeff00",
            CenterName: "Innovation Center B2",
            Users: [
              {
                UserGuidDetails: "9ddf50b4-5f4e-47ee-9999-ccddee445566",
                DisplayName: "Isabella Rossi"
              },
              {
                UserGuidDetails: "0eea33c3-6b6b-41ac-9999-ccddeeff1122",
                DisplayName: "James Smith"
              }
            ]
          }
        ]
      },
      {
        SubGroupId: "22222222-2222-2222-2222-222222222222",
        SubGroupName: "Subgroup C",
        CallCenters: [],
        Centers: [
          {
            CenterId: "d4455667-7788-8899-99aa-bbccddeeff11",
            CenterName: "Operations Center C1",
            Users: [
              {
                UserGuidDetails: "f1234567-89ab-4cde-f012-3456789abcde",
                DisplayName: "Carlos Mendoza"
              },
              {
                UserGuidDetails: "e9876543-21ba-43fe-c012-3456789fedcb",
                DisplayName: "Elena Petrova"
              },
              {
                UserGuidDetails: "a1111111-b222-4ccc-d333-555555555555",
                DisplayName: "Liam O'Connor"
              }
            ]
          }
        ]
      }
    ]
  }
];

export interface UserRolePermisions {
  GroupId: string,
  SubgroupId: string,
  CallCenterId: string,
  CenterId: string,
  UserId: string,
}

export interface RoleFilterIds {
  GroupIds?: string[],
  SubGroupIds?: string[],
  CallCenterIds: string[],
  CenterIds?: string[],
  UserIds?: string[],
}

@Injectable({
  providedIn: 'root'
})
export class RoleFilterService {

  constructor(private localStorageService: LocalStorageService, private UserService: UserService,
    private http: HttpClient,
    private authService: AuthService,
    private MyAccountService: MyAccountService
  ) { }

  EmptyRoleFilter: RoleFilterSelected = this.getEmptyRoleFilter()

  url = environment.tracking_url;
  urlIdentity = environment.identity_url;

  getEmptyRoleFilter(): RoleFilterSelected {
    return {
      Groups: [],
      SubGroups: [],
      CallCenters: [],
      Centers: [],
      Users: [],
    }
  }
  getRoleFilterData(): Observable<HierarchicalData | null> {
    const responseStr: HierarchicalData | null = this.localStorageService.get(LocalStorageKeys.RoleFilterResponseFormated);

    if (responseStr) {
      const stored = responseStr;
      return of(stored);
    }

    return this.getRoleFilterDataAndFormat();

  }

  setRoleFilterStorage(roleStorage: RoleFilterSelected): void {
    this.localStorageService.set(LocalStorageKeys.RoleFilters, roleStorage)
  }

  getRoleFilterStorage(): RoleFilterSelected {
    const storage: RoleFilterSelected | null = this.localStorageService.get(LocalStorageKeys.RoleFilters)
    if (storage) {
      return storage;
    }
    return {
      Groups: [],
      SubGroups: [],
      CallCenters: [],
      Centers: [],
      Users: [],
    };
  }
  removeRoleFilterStorge(): void {
    this.localStorageService.remove(LocalStorageKeys.RoleFilters)
  }

  buildFiltersAndCall(userProfile: UserProfile | null): Observable<HierarchicalData | null> {
    if (!userProfile) return of(null);

    const UserRolesInfo: RoleFilterIds = {
      GroupIds: [],
      SubGroupIds: [],
      CallCenterIds: [],
      CenterIds: [],
      UserIds: [],
    };

    if (userProfile.GroupId) UserRolesInfo.GroupIds = [userProfile.GroupId];
    if (userProfile.SubGroupId) UserRolesInfo.SubGroupIds = [userProfile.SubGroupId];
    if (userProfile.CallCenterId) UserRolesInfo.CallCenterIds = [userProfile.CallCenterId];
    if (userProfile.CenterId) UserRolesInfo.CenterIds = [userProfile.CenterId];

    return this.getRoleFilterDataBack(UserRolesInfo).pipe(
      take(1),
      map((response: GroupsResponse) => {
        const formatted = this.convertToHierarchicalData(response);
        this.localStorageService.set(LocalStorageKeys.RoleFilterResponseFormated, formatted);
        return formatted;
      }),
      catchError((error) => {
        console.error('[RoleFilterService]: Error fetching role filter data:', error);
        return of(null);
      })
    );
  };
  getRoleFilterDataAndFormat(): Observable<HierarchicalData | null> {
    const userNow: UserProfile | null = this.MyAccountService.getUserDetailLocal();
    if (userNow) {
      return this.buildFiltersAndCall(userNow);
    }

    return this.MyAccountService.userUpdated$.pipe(
      take(1),
      switchMap((user: UserProfile | null) => this.buildFiltersAndCall(user)),
      catchError(() => {
        console.log('Error fetching user details for role filter');
        return of(null);
      })
    );
  }
  getRoleFilterDataBack(UserRolesInfo: RoleFilterIds): Observable<GroupsResponse> {
    return this.http.post<GroupsResponse>(`${this.urlIdentity}/user/me/group-structure`, UserRolesInfo);
  }

  convertRoleFilterSelected_To_RoleFilterIds(filters: RoleFilterSelected): RoleFilterIds {
    const RoleFilterIds: RoleFilterIds = {
      GroupIds: this.mapToIds(filters.Groups),
      SubGroupIds: this.mapToIds(filters.SubGroups),
      CallCenterIds: this.mapToIds(filters.CallCenters),
      CenterIds: this.mapToIds(filters.Centers),
      UserIds: this.mapToIds(filters.Users),
    }
    return RoleFilterIds
  }

  convertRoleFilterSelected_To_RoleFilterGuid(filters: RoleFilterSelected): RoleFiltesGuid {
    return {
      GroupGuids: this.mapToIds(filters.Groups),
      SubGroupGuids: this.mapToIds(filters.SubGroups),
      CallCenterGuids: this.mapToIds(filters.CallCenters),
      CenterGuids: this.mapToIds(filters.Centers),
      UserGuids: this.mapToIds(filters.Users)
    };
  }

  private mapToIds(items?: OptionItem[]): string[] {
    return items?.map(item => item.id) ?? [];
  }

  /***********************
   *  conversión de respuesta -> HierarchicalData
   *  (mantengo tu implementación original adaptada al tipo OptionItem)
   ***********************/
  convertToHierarchicalData(response: GroupsResponse): HierarchicalData {

    const result: HierarchicalData = {
      subGroups: [],
      centersBySubGroup: {},
      callCentersBySubGroup: {},
      centersByCallCenters: {},
      usersByCallCenters: {}, // <-- NUEVO
      usersByCenter: {},
      allCallCenters: [],
      allCenters: [],
      allUsers: [],
    };

    const subGroupMap = new Map<string, boolean>();
    const callCentersMap = new Map<string, boolean>();
    const centerMap = new Map<string, boolean>();
    const userMap = new Map<string, boolean>();

    let validSubGroupCount = 0;
    let validCallCenterCount = 0;
    let validCenterCount = 0;

    response.forEach((group: Group) => {

      group.SubGroups?.forEach((subGroup: SubGroup) => {

        const subGroupId = subGroup.SubGroupId;
        const subGroupName = subGroup.SubGroupName?.trim() || '(Sin nombre)';

        if (subGroupId && !subGroupMap.has(subGroupId)) {
          result.subGroups.push({ id: subGroupId, name: subGroupName });
          subGroupMap.set(subGroupId, true);
        }

        if (subGroupId) {
          validSubGroupCount++;

          result.centersBySubGroup[subGroupId] ??= [];
          result.callCentersBySubGroup[subGroupId] ??= [];
        }

        // -------------------------
        // CENTERS DIRECTOS DEL SUBGRUPO
        // -------------------------
        subGroup.Centers?.forEach((center: Center) => {

          const centerId = center.CenterId;
          const centerName = center.CenterName?.trim() || '(Sin nombre)';

          if (subGroupId && centerId) {
            result.centersBySubGroup[subGroupId].push({ id: centerId, name: centerName });
          }

          if (centerId && !centerMap.has(centerId)) {
            result.allCenters.push({ id: centerId, name: centerName });
            centerMap.set(centerId, true);
          }

          if (centerId) {
            validCenterCount++;

            result.usersByCenter[centerId] = center.Users?.map(u => ({
              id: u.UserGuidDetails,
              name: u.DisplayName?.trim() || '(Sin nombre)'
            })) || [];
          }

          // 👇 AUNQUE NO HAYA centerId, los usuarios van a allUsers
          center.Users?.forEach((u: any) => {
            const userId = u.UserGuidDetails;
            const userName = u.DisplayName?.trim() || '(Sin nombre)';

            if (userId && !userMap.has(userId)) {
              result.allUsers.push({ id: userId, name: userName });
              userMap.set(userId, true);
            }
          });

        });

        // -------------------------
        // CALL CENTERS DEL SUBGRUPO
        // -------------------------
        subGroup.CallCenters?.forEach((callCenter: CallCenter) => {

          const callCenterId = callCenter.CallCenterId;
          const callCenterName = callCenter.CallCenterName?.trim() || '(Sin nombre)';

          if (subGroupId && callCenterId) {
            result.callCentersBySubGroup[subGroupId].push({
              id: callCenterId,
              name: callCenterName
            });
          }

          if (callCenterId) {
            validCallCenterCount++;
          }

          if (callCenterId && !callCentersMap.has(callCenterId)) {
            result.allCallCenters.push({
              id: callCenterId,
              name: callCenterName
            });
            callCentersMap.set(callCenterId, true);
          }

          if (callCenterId) {
            result.centersByCallCenters[callCenterId] ??= [];
            result.usersByCallCenters[callCenterId] ??= []; // <-- NUEVO
          }

          callCenter.Centers?.forEach((center: Center) => {

            const centerId = center.CenterId;
            const centerName = center.CenterName?.trim() || '(Sin nombre)';

            if (callCenterId && centerId) {
              result.centersByCallCenters[callCenterId].push({
                id: centerId,
                name: centerName
              });
            }

            if (centerId && !centerMap.has(centerId)) {
              result.allCenters.push({ id: centerId, name: centerName });
              centerMap.set(centerId, true);
            }

            if (centerId) {
              result.usersByCenter[centerId] ??= [];
            }

            center.Users?.forEach((u: any) => {

              const userId = u.UserGuidDetails;
              const userName = u.DisplayName?.trim() || '(Sin nombre)';

              if (userId && !userMap.has(userId)) {
                result.allUsers.push({ id: userId, name: userName });
                userMap.set(userId, true);
              }

              // usersByCenter (solo si hay centerId)
              if (centerId && userId &&
                !result.usersByCenter[centerId].some(x => x.id === userId)) {

                result.usersByCenter[centerId].push({
                  id: userId,
                  name: userName
                });
              }

              // ✅ NUEVO: usersByCallCenters (aunque el center NO tenga id)
              if (callCenterId && userId &&
                !result.usersByCallCenters[callCenterId].some(x => x.id === userId)) {

                result.usersByCallCenters[callCenterId].push({
                  id: userId,
                  name: userName
                });

              }

            });

          });

        });

      });

    });

    (result as any)._validSubGroupCount = validSubGroupCount;
    (result as any)._validCallCenterCount = validCallCenterCount;
    (result as any)._validCenterCount = validCenterCount;

    return result;
  }



}
